import { FC, useState, useEffect } from 'react';

import { Step1 } from '@/components/Game/Steps/Step1';
import { Step2 } from '@/components/Game/Steps/Step2';
import { IBox, IBoxes } from '@/types/pack';

interface GameProps {
  step: number;
  totalPoints: number;
  configId: string;
  userToken: string;
  setStep: (value: number) => void;
}

const Game: FC<GameProps> = ({ configId, step, setStep, totalPoints, userToken }) => {
  const [idPack, setIdPack] = useState<number>(0);
  const [timer, setTimer] = useState(0);
  const [isNotification, setIsNotification] = useState(false);
  const [packs, setPacks] = useState<IBoxes[]>(); // TODO:: поправить
  const [points, setPoints] = useState<number>(0);
  const [pack, setPack] = useState<IBox>();
  const [isViewModal, setIsViewModal] = useState<boolean>();
  const [currentList, setCurrentList] = useState('');
  const [firstPlay, setFirstPlay] = useState(false);

  useEffect(() => {
    fetch(`https://admin.znatok.jti-games.dev.familyagency.ru/api/timer`)
      .then((response) => response.json())
      .then((data) => setTimer(data.time));
  }, []);

  useEffect(() => {
    if (userToken) {
      fetch(`https://admin.znatok.jti-games.dev.familyagency.ru/api/modal`, {
        headers: {
          UserToken: userToken,
        },
      })
        .then((response) => response.json())
        .then(({ data }) => setIsViewModal(data.isViewModal));
    }
  }, [userToken, idPack]);

  return (
    <>
      {step === 3 && (
        <Step1
          totalPoints={totalPoints}
          userToken={userToken}
          setStep={setStep}
          setIdPack={setIdPack}
          timer={timer}
          isNotification={isNotification}
          setIsNotification={setIsNotification}
          setPackss={setPacks}
          points={points}
          setPoints={setPoints}
          currentPack={pack}
          isViewModal={isViewModal}
          currentList={currentList}
          setCurrentList={setCurrentList}
          firstPlay={firstPlay}
        />
      )}
      {step === 4 && (
        <Step2
          configId={configId}
          userToken={userToken}
          idPack={idPack}
          setStep={setStep}
          timer={timer}
          totalPoints={totalPoints}
          setIsNotification={setIsNotification}
          packs={packs}
          points={points}
          pack={pack}
          setPack={setPack}
          isViewModal={isViewModal}
          firstPlay={firstPlay}
          setFirstPlay={setFirstPlay}
        />
      )}
    </>
  );
};

export default Game;
